import React, { useState, useEffect, useCallback } from 'react';

// --- Icon Lucide ---
const MenuIcon = ({ className = "w-6 h-6" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>
);
const XIcon = ({ className = "w-6 h-6" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
);
const BuildingIcon = ({ className = "w-5 h-5 mr-2" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><rect x="2" y="2" width="20" height="20" rx="2" ry="2"></rect><path d="M9 22V12h6v10"></path><path d="M2 10h20"></path><path d="M6 18H2"></path><path d="M18 18h4"></path><path d="M6 14H2"></path><path d="M18 14h4"></path><path d="M6 10H2"></path><path d="M18 10h4"></path><path d="M6 6H2"></path><path d="M18 6h4"></path></svg>
);
const LightbulbIcon = ({ className = "w-5 h-5 mr-2" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M12 2.004a7 7 0 0 0-5.03 11.998A4.995 4.995 0 0 0 12 22a4.995 4.995 0 0 0 5.03-8.002A7 7 0 0 0 12 2.004z"></path><path d="M12 22v-2.5"></path><path d="M8.03 17.498l1.414 1.414"></path><path d="M14.556 18.912l1.414-1.414"></path><path d="M2 12h2.5"></path><path d="M19.5 12H22"></path><path d="M8.03 6.502l1.414-1.414"></path><path d="M14.556 5.088l1.414 1.414"></path></svg>
);
const PhoneIcon = ({ className = "w-5 h-5 mr-2" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
);
const ChevronLeftIcon = ({ className = "w-6 h-6" }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M15 18l-6-6 6-6"/></svg>
);
const ChevronRightIcon = ({ className = "w-6 h-6" }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M9 18l6-6-6-6"/></svg>
);
// Tambahkan di deretan komponen icon (di bawah ChevronRightIcon)
const ShieldCheckIcon = ({ className = "w-6 h-6" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path><path d="M9 12l2 2 4-4"></path></svg>
);
const CpuIcon = ({ className = "w-6 h-6" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><rect x="4" y="4" width="16" height="16" rx="2" ry="2"></rect><rect x="9" y="9" width="6" height="6"></rect><line x1="9" y1="1" x2="9" y2="4"></line><line x1="15" y1="1" x2="15" y2="4"></line><line x1="9" y1="20" x2="9" y2="23"></line><line x1="15" y1="20" x2="15" y2="23"></line><line x1="20" y1="9" x2="23" y2="9"></line><line x1="20" y1="14" x2="23" y2="14"></line><line x1="1" y1="9" x2="4" y2="9"></line><line x1="1" y1="14" x2="4" y2="14"></line></svg>
);
const UsersIcon = ({ className = "w-6 h-6" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
);
const ShoppingBagIcon = ({ className = "w-5 h-5" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
    <line x1="3" y1="6" x2="21" y2="6"></line>
    <path d="M16 10a4 4 0 0 1-8 0"></path>
  </svg>
);
const MapPinIcon = ({ className = "w-5 h-5" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
);
const MailIcon = ({ className = "w-5 h-5" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><rect width="20" height="16" x="2" y="4" rx="2"></rect><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path></svg>
);
const ClockIcon = ({ className = "w-5 h-5" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
);
const SendIcon = ({ className = "w-5 h-5" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><line x1="22" x2="11" y1="2" y2="13"></line><polygon points="22 2 15 22 11 13 2 9 22 2"></polygon></svg>
);

// --- Komponen Banner ---
const PageBanner = ({ title, imageUrl }) => (
    <section className="relative h-64 md:h-80 w-full">
        <div 
            className="absolute top-0 left-0 w-full h-full bg-cover bg-center"
            style={{ backgroundImage: `url(${imageUrl})` }}
        />
        <div className="absolute top-0 left-0 w-full h-full bg-black/60 flex justify-center items-center">
            {/* Penambahan font-heading */}
            <h1 className="text-4xl md:text-5xl font-bold font-heading text-white drop-shadow-lg">{title}</h1>
        </div>
    </section>
);

// --- Komponen Slideshow ---
const Slideshow = ({ slides, height = 'h-[500px]', autoPlay = true }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const prevSlide = useCallback(() => {
        const isFirstSlide = currentIndex === 0;
        const newIndex = isFirstSlide ? slides.length - 1 : currentIndex - 1;
        setCurrentIndex(newIndex);
    }, [currentIndex, slides.length]);

    const nextSlide = useCallback(() => {
        const isLastSlide = currentIndex === slides.length - 1;
        const newIndex = isLastSlide ? 0 : currentIndex + 1;
        setCurrentIndex(newIndex);
    }, [currentIndex, slides.length]);

    useEffect(() => {
        if (autoPlay && slides.length > 1) {
            const timer = setTimeout(nextSlide, 5000);
            return () => clearTimeout(timer);
        }
    }, [currentIndex, nextSlide, autoPlay, slides.length]);

    if (!slides || slides.length === 0) {
        return <div className={`w-full ${height} bg-slate-200 flex items-center justify-center rounded-lg`}><p>No Images</p></div>;
    }

    return (
        <div className={`w-full ${height} m-auto relative group rounded-2xl overflow-hidden shadow-xl bg-slate-100`}>
            
            {/* Gambar Slide (Dibuat full cover area) */}
            <div 
                style={{ backgroundImage: `url(${slides[currentIndex].url})` }} 
                className="absolute inset-0 w-full h-full bg-center bg-cover transition-all duration-500 ease-in-out"
            ></div>
            
            {slides.length > 1 && (
                <>
                    {/* Tombol Kiri (Sekarang menggunakan tag button yang lebih valid) */}
                    <button 
                        type="button"
                        onClick={(e) => { 
                            e.preventDefault();
                            e.stopPropagation(); 
                            prevSlide(); 
                        }} 
                        className="absolute top-1/2 -translate-y-1/2 left-4 z-[50] flex items-center justify-center w-12 h-12 rounded-full bg-black/40 hover:bg-black/80 text-white cursor-pointer transition-all duration-300 opacity-0 group-hover:opacity-100 focus:outline-none shadow-lg"
                        aria-label="Geser Kiri"
                    >
                        <ChevronLeftIcon className="w-8 h-8" />
                    </button>
                    
                    {/* Tombol Kanan */}
                    <button 
                        type="button"
                        onClick={(e) => { 
                            e.preventDefault();
                            e.stopPropagation(); 
                            nextSlide(); 
                        }} 
                        className="absolute top-1/2 -translate-y-1/2 right-4 z-[50] flex items-center justify-center w-12 h-12 rounded-full bg-black/40 hover:bg-black/80 text-white cursor-pointer transition-all duration-300 opacity-0 group-hover:opacity-100 focus:outline-none shadow-lg"
                        aria-label="Geser Kanan"
                    >
                        <ChevronRightIcon className="w-8 h-8" />
                    </button>
                    
                    {/* Navigasi Titik (Dots) */}
                    <div className="absolute bottom-4 left-0 right-0 z-[50] flex justify-center py-2 pointer-events-none">
                        {/* pointer-events-none pada div agar tidak menghalangi, lalu kita nyalakan lagi di button */}
                        <div className="pointer-events-auto flex">
                            {slides.map((slide, slideIndex) => (
                                <button 
                                    key={slideIndex}
                                    type="button" 
                                    onClick={(e) => { 
                                        e.preventDefault();
                                        e.stopPropagation(); 
                                        setCurrentIndex(slideIndex); 
                                    }} 
                                    className={`text-2xl cursor-pointer mx-1 transition-colors duration-300 focus:outline-none ${currentIndex === slideIndex ? 'text-orange-500 drop-shadow-md' : 'text-white/50 hover:text-white'}`}
                                >
                                    ●
                                </button>
                            ))}
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};
// --- Komponen Halaman ---
const HomePage = ({ navigate }) => {
    const mainSlides = [
        { url: 'https://ik.imagekit.io/DBoyz/images/Contoh%20Produk', title: 'Produk Unggulan Kami', subtitle: 'Kualitas dan presisi dalam setiap detail produk yang kami hasilkan.' },
        { url: 'https://ik.imagekit.io/DBoyz/images/Contoh%20Produksi', title: 'Proses Produksi Modern', subtitle: 'Menggunakan teknologi canggih untuk efisiensi dan hasil yang konsisten.' },
        { url: 'https://ik.imagekit.io/DBoyz/images/Tim%20Profesional%20', title: 'Tim Profesional & Berpengalaman', subtitle: 'Didukung oleh para ahli yang berdedikasi untuk memberikan yang terbaik.' },
        { url: 'https://ik.imagekit.io/DBoyz/images/Tim%20Tata', title: 'Inovasi Tiada Henti', subtitle: 'Selalu mencari solusi baru untuk menjawab tantangan masa depan.' },
    ];
    
    const factorySlides = [
        { url: 'https://ik.imagekit.io/DBoyz/images/Suasana%20Pabrik', title: 'Area Produksi' },
        { url: 'https://ik.imagekit.io/DBoyz/images/Mesin%201', title: 'Mesin Presisi' },
        { url: 'https://ik.imagekit.io/DBoyz/images/Mesin%202', title: 'Gudang Penyimpanan' },
        { url: 'https://ik.imagekit.io/DBoyz/images/Mesin%203', title: 'Kontrol Kualitas' },
    ];

    const productSlides = [
        { url: 'https://ik.imagekit.io/DBoyz/images/Produk1.jpeg', title: 'Produk A Unggulan' },
        { url: 'https://ik.imagekit.io/DBoyz/images/Emboss.jpg', title: 'Produk B Inovatif' },
        { url: 'https://ik.imagekit.io/DBoyz/images/Decal.jpg', title: 'Produk C Premium' },
        { url: 'https://ik.imagekit.io/DBoyz/images/Dome.jpg', title: 'Produk D Ekonomis' },
    ];

    const [currentMainSlide, setCurrentMainSlide] = useState(0);

    const nextMainSlide = useCallback(() => {
        setCurrentMainSlide(prev => (prev === mainSlides.length - 1 ? 0 : prev + 1));
    }, [mainSlides.length]);

    useEffect(() => {
        const timer = setTimeout(nextMainSlide, 7000);
        return () => clearTimeout(timer);
    }, [currentMainSlide, nextMainSlide]);

    return (
        <div className="w-full">
{/* 1. Fullscreen Slideshow */}
            <section className="relative h-screen w-full">
                {mainSlides.map((slide, index) => (
                    <div
                        key={index}
                        className="absolute inset-0 w-full h-full bg-cover bg-center transition-opacity duration-1000 ease-in-out"
                        style={{ 
                            backgroundImage: `url(${slide.url})`,
                            opacity: index === currentMainSlide ? 1 : 0,
                        }}
                    />
                ))}
                
                {/* Overlay gelap dan area konten yang sudah dipastikan rata tengah */}
                <div className="absolute inset-0 bg-black/50 flex flex-col justify-center items-center text-center text-white p-4">
                    
                    {/* Tambahan w-full, flex, dan items-center agar tidak lari ke kiri */}
                    <div key={currentMainSlide} className="animate-fade-in w-full flex flex-col items-center">
                        <h1 className="text-4xl md:text-6xl font-bold font-heading mb-6 drop-shadow-lg max-w-4xl mx-auto">
                            {mainSlides[currentMainSlide].title}
                        </h1>
                        <p className="text-lg md:text-2xl max-w-2xl mx-auto mb-10 drop-shadow-md text-slate-200">
                            {mainSlides[currentMainSlide].subtitle}
                        </p>
                    </div>

                    <button 
                        onClick={() => navigate('produk')}
                        className="bg-orange-500 hover:bg-orange-600 text-white font-semibold py-4 px-8 rounded-xl shadow-[0_4px_20px_rgb(249,115,22,0.3)] hover:shadow-[0_4px_25px_rgb(249,115,22,0.5)] transition-all duration-300 ease-in-out transform hover:-translate-y-1 text-lg z-10"
                    >
                        Jelajahi Produk
                    </button>
                </div>
            </section>

            <section className="py-16 md:py-24 bg-white">
                <div className="container mx-auto px-6 text-center max-w-4xl">
                    <h2 className="text-3xl md:text-4xl font-bold font-heading text-slate-800 mb-4">Sejarah Singkat Perusahaan</h2>
                    <div className="w-24 h-1 bg-orange-500 mx-auto mb-6"></div>
                    <p className="text-gray-600 leading-relaxed font-sans text-justify">
PT. TATA INOVINDO yang berdiri pada tahun 2011 adalah merupakan perusahaan Pengembangan dari CV.Tata Inovindo (2006). Pada awal berdirinya CV Tata Inovindo hanya melayani pembuatan masking painting (Support produksi painting OEM). Seiring dengan permintaan / peluang yang diberikan customer dan pengembangan usaha, maka pada tahun 2011 dibentuklah divisi screen printing dan cutting material. Dimana Sebagian besar produk yang dihasilkan adalah OEM dan Sparepart yang bergerak dibidang otomotif dan elektronik. Hingga akhirnya PT TATA INOVINDO dikukuhkan sebagai Perusahaan dengan pemetaan bisnis percetakan sablon (silk printing), Cutting Stiker (Plotter, Converting dan Die Cutting) untuk OEM (Automotif dan Elektronik) dan Aksesoris.                    </p>
                </div>
            </section>

            <section className="py-16 md:py-24 bg-slate-50">
                <div className="container mx-auto px-6">
<div className="text-center mb-12">
                        <h2 className="text-3xl md:text-4xl font-bold font-heading text-slate-800">Fasilitas dan Teknologi</h2>
                        {/* Garis oranye ditambahkan di sini */}
                        <div className="w-24 h-1 bg-orange-500 mx-auto mt-5 mb-3 rounded-full"></div>
                        <p className="text-gray-600 mt-2">Intip Dapur Produksi Kami</p>
                    </div>                    <Slideshow slides={factorySlides} height="h-[400px] md:h-[500px]" />
                </div>
            </section>

            <section className="py-16 md:py-24 bg-white">
                <div className="container mx-auto px-6">
<div className="text-center mb-12">
                        <h2 className="text-3xl md:text-4xl font-bold font-heading text-slate-800">Mengapa Memilih Kami?</h2>
                        {/* Garis oranye ditambahkan di sini */}
                        <div className="w-24 h-1 bg-orange-500 mx-auto mt-5 mb-3 rounded-full"></div>
                        <p className="text-gray-600 mt-2">Keunggulan yang Kami Tawarkan</p>
                    </div>                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {/* Kartu 1: Kualitas */}
                        <div className="bg-white p-8 rounded-3xl shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 hover:shadow-[0_8px_30px_rgb(249,115,22,0.1)] hover:-translate-y-2 transition-all duration-300 group">
                            <div className="w-14 h-14 bg-orange-50 text-orange-500 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-orange-500 group-hover:text-white transition-colors duration-300">
                                <ShieldCheckIcon className="w-7 h-7" />
                            </div>
                            <h3 className="text-xl font-bold font-heading text-slate-800 mb-3 group-hover:text-orange-600  transition-colors duration-300">Kualitas</h3>
                            <p className="text-gray-600 text-sm leading-relaxed text-justify">Dengan pengalaman lebih dari 10 tahun kami berkomitmen untuk memenuhi requirement customer, terutama yang berkaitan dengan kualitas material dan didukung manajemen bersertifikat ISO 9001 - 2015.</p>
                        </div>

                        {/* Kartu 2: Teknologi */}
                        <div className="bg-white p-8 rounded-3xl shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 hover:shadow-[0_8px_30px_rgb(249,115,22,0.1)] hover:-translate-y-2 transition-all duration-300 group">
                            <div className="w-14 h-14 bg-blue-50 text-blue-500 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-blue-500 group-hover:text-white transition-colors duration-300">
                                <CpuIcon className="w-7 h-7" />
                            </div>
                            <h3 className="text-xl font-bold font-heading text-slate-800 mb-3 group-hover:text-blue-600 transition-colors duration-300">Teknologi</h3>
                            <p className="text-gray-600 text-sm leading-relaxed text-justify">Sesuai dengan misi kami yang selalu berinovasi, Kami terus mengikuti perkembangan teknologi terkait proses kerja, mesin pendukung, dan sistem manajemen yang mutakhir.</p>
                        </div>

                        {/* Kartu 3: Team Work */}
                        <div className="bg-white p-8 rounded-3xl shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 hover:shadow-[0_8px_30px_rgb(249,115,22,0.1)] hover:-translate-y-2 transition-all duration-300 group">
                            <div className="w-14 h-14 bg-emerald-50 text-emerald-500 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-emerald-500 group-hover:text-white transition-colors duration-300">
                                <UsersIcon className="w-7 h-7" />
                            </div>
                            <h3 className="text-xl font-bold font-heading text-slate-800 mb-3 group-hover:text-emerald-600 transition-colors duration-300">Team Work</h3>
                            <p className="text-gray-600 text-sm leading-relaxed text-justify">Didukung man power yang ahli di bidangnya, kami menyiapkan sistem kerja kolaboratif yang membuat requirement customer kami dapat terpenuhi dengan nyaman dan presisi.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-16 md:py-24 bg-slate-50">
                <div className="container mx-auto px-6">
<div className="text-center mb-12">
                        <h2 className="text-3xl md:text-4xl font-bold font-heading text-slate-800">Produk Unggulan Kami</h2>
                        {/* Garis oranye ditambahkan di sini */}
                        <div className="w-24 h-1 bg-orange-500 mx-auto mt-5 mb-3 rounded-full"></div>
                        <p className="text-gray-600 mt-2">Hasil Karya Terbaik dari Fasilitas Kami</p>
                    </div>                    <Slideshow slides={productSlides} height="h-[400px] md:h-[500px]" />
                </div>
            </section>
        </div>
    );
};

const AboutPage = () => (
    <>
        <PageBanner title="Tentang Kami" imageUrl="https://ik.imagekit.io/DBoyz/images/Pabrik1.jpg?updatedAt=1752045221325"/>
        <div className="bg-slate-50">
            <div className="container mx-auto p-8 space-y-12">
                <section className="bg-white p-6 rounded-lg shadow-lg">
                <h3 className="text-2xl font-semibold font-heading text-orange-600 mb-3 flex items-center"><BuildingIcon /> Organisasi Kami</h3>
                <p className="text-gray-700 leading-relaxed text-justify">
    PT. TATA INOVINDO yang berdiri pada tahun 2011 adalah merupakan perusahaan Pengembangan dari CV.Tata Inovindo (2006). Pada awal berdirinya CV Tata Inovindo hanya melayani pembuatan masking painting (Support produksi painting OEM). Seiring dengan permintaan / peluang yang diberikan customer dan pengembangan usaha, maka pada tahun 2011 dibentuklah divisi screen printing dan cutting material. Dimana Sebagian besar produk yang dihasilkan adalah OEM dan Sparepart yang bergerak dibidang otomotif dan elektronik. Hingga akhirnya PT TATA INOVINDO dikukuhkan sebagai Perusahaan dengan pemetaan bisnis percetakan sablon (silk printing), Cutting Stiker (Plotter, Converting dan Die Cutting) untuk OEM (Automotif dan Elektronik) dan Aksesoris.      </p>
                </section>

<section className="bg-white p-8 rounded-3xl shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 ">                <h3 className="text-2xl font-semibold font-heading text-orange-600 mb-3 flex items-center"><LightbulbIcon /> Visi Kami</h3>
      <p className="text-gray-700 leading-relaxed text-justify">Menjadi perusahaan screen printing dan cutting berinovasi terbaik di Indonesia</p>
                </section>

                <section className="bg-white p-6 rounded-lg shadow-lg">
      <h3 className="text-2xl font-semibold font-heading text-orange-600 mb-3 flex items-center"><LightbulbIcon /> Misi Kami</h3>
      <ul className="space-y-8"> 
        <li className="border-l-4 border-orange-500 pl-4 py-3 bg-orange-50/50 rounded-r-md shadow-sm">
          <h4 className="text-xl font-semibold font-heading text-slate-800 mb-2">1. Memberikan</h4>
          <ul className="list-disc list-inside space-y-1 text-gray-600 text-sm pl-2 text-justify">
            <li>Jasa dan produk terbaik sesuai harapan pelanggan.</li>
            <li>Pelayanan delivery tepat waktu.</li>
            <li>Pemantauan terhadap produk yang dhasilkan dan sesudahnya (after sales).</li>
          </ul>
        </li>
        <li className="border-l-4 border-orange-500 pl-4 py-3 bg-orange-50/50 rounded-r-md shadow-sm">
          <h4 className="text-xl font-semibold font-heading text-slate-800 mb-2">2. Berinovasi</h4>
          <ul className="list-disc list-inside space-y-1 text-gray-600 text-sm pl-2 text-justify">
            <li>Pada pengembangan teknologi, riset dan analisa untuk perbaikan dan hasil yang lebih efektif dan efisien</li>
            <li>Pada upaya penggunaan bahan baku yang ramah lingkungan dan memenuhi persyaratan dunia kesehatan</li>
            <li>Pada upaya yang lebih baik dan terus menerus dalam menciptakan lingkungan kerja yang aman dan terpelihara guna meningkatkan kesejahteraan karyawan serta lingkungan sekitar sesuai dengan perundangan yang ada.</li>
          </ul>
        </li>
      </ul>
    </section>

                   <section className="bg-white p-6 rounded-lg shadow-lg">
        <h3 className="text-2xl font-semibold font-heading text-orange-600 mb-4 text-center">Fasilitas Kami</h3>
        <div className="w-full overflow-hidden rounded-lg">
            <img src="https://ik.imagekit.io/DBoyz/images/Pabrik1.jpg" alt="Gedung Perusahaan" className="w-full h-auto object-cover" />
        </div>

    </section>
            </div>
        </div>
    </>
);

const ProductsPage = ({ navigate }) => {
    const [selectedProduct, setSelectedProduct] = useState(null);
    const productsData = [
      { id: 1, name: "Label", images: [{ url: "https://ik.imagekit.io/DBoyz/images/Labeling.jpg" }, { url: "https://ik.imagekit.io/DBoyz/images/Label%202" }, { url: "https://ik.imagekit.io/DBoyz/images/Contoh%20Produksi" }], longDescription: "Pembuatan label untuk berbagai kebutuhan produk dan industri dengan pilihan material serta finishing yang dapat disesuaikan dengan aplikasi penggunaannya." },
      { id: 2, name: "Emboss", images: [{ url: "https://ik.imagekit.io/DBoyz/images/Emboss.jpg" }, { url: "https://ik.imagekit.io/DBoyz/images/Soft%20Emblem.jpg" }], longDescription: "Layanan emboss untuk menghasilkan efek timbul yang memberikan nilai tambah pada tampilan produk, kemasan, maupun media promosi." },
      { id: 3, name: "Sticker", images: [{ url: "https://ik.imagekit.io/DBoyz/images/Stiker%201" }, { url: "https://ik.imagekit.io/DBoyz/images/Stiker%202" }], longDescription: "Penyediaan sticker untuk kebutuhan branding, informasi produk, promosi, dan aplikasi industri dengan berbagai pilihan bahan dan finishing." },
      { id: 4, name: "Waterdecal", images: [{ url: "https://ik.imagekit.io/DBoyz/images/Decal.jpg" }, { url: "https://ik.imagekit.io/DBoyz/images/Decal%20Helm" }], longDescription: "Pembuatan water decal dengan hasil detail yang presisi untuk berbagai kebutuhan dekorasi dan identifikasi pada permukaan tertentu." },
      { id: 5, name: "Converting", images: [{ url: "https://ik.imagekit.io/DBoyz/images/Converting.jpg" }], longDescription: "Layanan pengolahan material seperti slitting, die-cutting, laminasi, dan proses pendukung lainnya guna memenuhi kebutuhan produksi secara optimal." },
      { id: 6, name: "Other", images: [{ url: "https://ik.imagekit.io/DBoyz/images/Pet%20Printing.jpg" }, { url: "https://ik.imagekit.io/DBoyz/images/Dome.jpg" }], longDescription: "Memiliki kebutuhan yang tidak termasuk dalam kategori di atas? Kami siap membantu menyediakan solusi yang dirancang sesuai dengan kebutuhan dan spesifikasi yang Anda perlukan." },
    ];

    return (
      <>
        <PageBanner title="Galeri Produk" imageUrl="https://ik.imagekit.io/DBoyz/images/Contoh%20Produksi"/>
        <div className="bg-slate-50">
            <div className="container mx-auto p-8">
                <div className="text-center mb-12">
                    <p className="text-gray-600 mt-2 max-w-2xl mx-auto">Klik pada produk untuk melihat galeri gambar dan detail lebih lanjut.</p>
                </div>
                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
                {productsData.map(product => (
                    <div 
                        key={product.id} 
                        onClick={() => setSelectedProduct(product)} 
                        className="relative rounded-2xl shadow-sm border border-slate-200 overflow-hidden h-72 transition-all duration-500 hover:shadow-2xl hover:-translate-y-2 cursor-pointer group"
                    >
                        {/* Gambar dengan efek zoom lambat */}
                        <img 
                            src={product.images[0].url} 
                            alt={product.name} 
                            className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700 ease-out"
                        />
                        
                        {/* Gradasi hitam yang mulus (Gradient Overlay) */}
                        <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/40 to-transparent opacity-80 group-hover:opacity-95 transition-opacity duration-300"></div>
                        
                        {/* Teks dan Tombol yang beranimasi */}
                        <div className="absolute inset-0 flex flex-col justify-end p-6">
                            <h3 className="text-2xl font-bold font-heading text-white drop-shadow-md transform translate-y-3 group-hover:translate-y-0 transition-transform duration-300">
                                {product.name}
                            </h3>
                            
                            {/* Teks "Lihat Detail" akan muncul saat di-hover */}
                            <div className="overflow-hidden transition-all duration-300 max-h-0 opacity-0 group-hover:max-h-10 group-hover:opacity-100 group-hover:mt-2">
                                <span className="text-orange-400 text-sm font-medium flex items-center">
                                    Lihat Detail <ChevronRightIcon className="w-4 h-4 ml-1" />
                                </span>
                            </div>
                        </div>
                    </div>
                ))}
                </div>
            </div>
        </div>

{selectedProduct && (
          <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6">
            {/* Latar Belakang Blur (Backdrop) */}
            <div 
              className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm transition-opacity duration-300"
              onClick={() => setSelectedProduct(null)}
            ></div>

            {/* Kontainer Modal */}
            <div 
              className="relative bg-white rounded-3xl shadow-2xl w-full max-w-5xl flex flex-col md:flex-row overflow-hidden transform scale-95 opacity-100 animate-fade-in z-10"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Tombol Close di Pojok Kanan Atas */}
              <button 
                onClick={() => setSelectedProduct(null)} 
                className="absolute top-4 right-4 z-20 bg-white/80 backdrop-blur-md p-2 rounded-full text-slate-500 hover:text-white hover:bg-red-500 transition-all duration-300 shadow-sm hover:scale-110"
                aria-label="Tutup"
              >
                <XIcon className="w-5 h-5" />
              </button>

              {/* Area Kiri: Gambar Slideshow */}
              <div className="w-full md:w-1/2 bg-slate-50 h-72 md:h-[500px] relative">
                <Slideshow slides={selectedProduct.images} height="h-full" autoPlay={false} />
              </div>

              {/* Area Kanan: Detail Informasi */}
              <div className="w-full md:w-1/2 p-8 md:p-12 flex flex-col justify-center bg-white">
                
                {/* Badge Kategori */}
                <div className="mb-3">
                  <span className="inline-block px-4 py-1.5 bg-orange-50 text-orange-600 text-xs font-bold rounded-full tracking-wider uppercase border border-orange-100">
                    Produk Pilihan
                  </span>
                </div>

                {/* Judul Produk */}
                <h3 className="text-3xl md:text-4xl font-bold font-heading text-slate-800 mb-4">
                  {selectedProduct.name}
                </h3>

                {/* Garis Pemisah Elegan */}
                <div className="w-16 h-1 bg-slate-200 mb-6 rounded-full"></div>

                {/* Deskripsi */}
<p className="text-slate-600 mb-8 leading-relaxed text-base md:text-lg flex-grow text-justify">                  {selectedProduct.longDescription}
                </p>

                {/* Tombol Call to Action */}
                <div className="flex flex-col sm:flex-row gap-4 mt-auto pt-4 border-t border-slate-100">
                  <button 
                    onClick={() => {
                      navigate('kontak', { product: selectedProduct.name });
                      setSelectedProduct(null);
                    }}
                    className="flex-1 flex items-center justify-center bg-orange-500 hover:bg-orange-600 text-white font-semibold py-4 px-6 rounded-2xl transition duration-300 shadow-[0_8px_20px_rgb(249,115,22,0.3)] hover:shadow-[0_8px_25px_rgb(249,115,22,0.4)] hover:-translate-y-1"
                  >
                    <ShoppingBagIcon className="w-5 h-5 mr-2" />
                    Minta Penawaran
                  </button>
                </div>

              </div>
            </div>
          </div>
        )}
      </>
    );
};

const ContactPage = ({ initialProduct }) => {
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', product: initialProduct || '', message: '' });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [submitError, setSubmitError] = useState('');

  useEffect(() => { if (initialProduct) setFormData(prev => ({ ...prev, product: initialProduct })); }, [initialProduct]);
  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitError('');
    setIsSubmitted(false);
    
    if (!formData.name || !formData.email || !formData.message) return setSubmitError('Nama, Email, dan Pesan wajib diisi.');
    if (!/\S+@\S+\.\S+/.test(formData.email)) return setSubmitError('Format email tidak valid.');
    
    // URL Formspree Anda sudah dimasukkan di sini:
    const FORM_ENDPOINT = "https://formspree.io/f/mzdlezqa";

    try {
        // Proses mengirim data secara nyata via internet
        const response = await fetch(FORM_ENDPOINT, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "Nama Lengkap": formData.name,
                "Email Pengirim": formData.email,
                "No. Telepon": formData.phone || "Tidak diisi",
                "Produk Diminati": formData.product || "Tidak diisi",
                "Isi Pesan": formData.message
            })
        });

        // Jika server Formspree merespon sukses
        if (response.ok) {
            setIsSubmitted(true);
            setFormData({ name: '', email: '', phone: '', product: initialProduct || '', message: '' });
            setTimeout(() => setIsSubmitted(false), 5000);
        } else {
            throw new Error("Respon server gagal");
        }
    } catch (error) {
        setSubmitError('Terjadi kesalahan saat mengirim pesan. Pastikan Anda terhubung ke internet.');
    }
  };

  return (
    <>
        <PageBanner title="Hubungi Kami" imageUrl="https://ik.imagekit.io/DBoyz/images/Tim%20Tata"/>
        <div className="bg-slate-50 py-12 md:py-20">
            <div className="container mx-auto px-4 sm:px-6">
                
                {/* Kontainer Utama */}
                <div className="max-w-6xl mx-auto bg-white p-6 sm:p-10 md:p-12 rounded-[2rem] shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-slate-100">
                    
<div className="text-center mb-12">
                        <h2 className="text-3xl md:text-4xl font-bold font-heading text-slate-800 mb-4">Mari Bekerja Sama</h2>
                        {/* Garis oranye ditambahkan di sini */}
                        <div className="w-24 h-1 bg-orange-500 mx-auto mb-6 rounded-full"></div>
                        <p className="text-slate-500 max-w-2xl mx-auto text-sm md:text-base leading-relaxed ">
                            Kami siap membantu mewujudkan kebutuhan produk Anda dengan presisi dan kualitas terbaik. Silakan hubungi kami untuk berkonsultasi atau kunjungi fasilitas pabrik kami langsung.
                        </p>
                    </div>

                    <div className="grid lg:grid-cols-5 gap-10 lg:gap-16">
                        
                        {/* Kiri: Panel Informasi Kontak (Kartu Gelap) */}
{/* Kiri: Panel Informasi Kontak (Tema Terang) */}
                        <div className="lg:col-span-2 relative bg-orange-50/50 rounded-[2rem] p-8 md:p-10 text-slate-800 border border-orange-100 overflow-hidden group">
                            
                            {/* Dekorasi Latar Belakang Lingkaran Halus */}
                            <div className="absolute top-0 right-0 -mr-8 -mt-8 w-40 h-40 rounded-full bg-white/60 blur-xl group-hover:bg-white/80 transition-colors duration-700"></div>
                            <div className="absolute bottom-0 left-0 -ml-12 -mb-12 w-48 h-48 rounded-full bg-orange-200/20 blur-xl group-hover:bg-orange-200/40 transition-colors duration-700"></div>

                            <div className="relative z-10">
                                <h3 className="text-2xl font-bold font-heading mb-8 text-slate-800">Detail Kontak</h3>
                                
                                <div className="space-y-8">
                                    <div className="flex items-start">
                                        <div className="w-12 h-12 rounded-2xl bg-white shadow-sm border border-orange-100 flex items-center justify-center mr-5 flex-shrink-0 transition-transform group-hover:scale-105 duration-300">
                                            <MapPinIcon className="text-orange-500 w-6 h-6" />
                                        </div>
                                        <div className="pt-1">
                                            <p className="font-semibold mb-1 text-slate-800">Alamat Pabrik & Kantor</p>
                                            <p className="text-sm text-slate-600 leading-relaxed">Jalan Ciranjang 41 RT 01 RW 03 Pamoyanan, Bogor Selatan, Bogor, Jawa Barat</p>
                                        </div>
                                    </div>

                                    <div className="flex items-start">
                                        <div className="w-12 h-12 rounded-2xl bg-white shadow-sm border border-orange-100 flex items-center justify-center mr-5 flex-shrink-0 transition-transform group-hover:scale-105 duration-300">
                                            <PhoneIcon className="text-orange-500 w-6 h-6" />
                                        </div>
                                        <div className="pt-1">
                                            <p className="font-semibold mb-1 text-slate-800">Telepon</p>
                                            <a href="tel:[NomorTelepon]" className="text-sm text-slate-600 hover:text-orange-500 transition-colors font-medium">085186837474</a>
                                        </div>
                                    </div>

                                    <div className="flex items-start">
                                        <div className="w-12 h-12 rounded-2xl bg-white shadow-sm border border-orange-100 flex items-center justify-center mr-5 flex-shrink-0 transition-transform group-hover:scale-105 duration-300">
                                            <MailIcon className="text-orange-500 w-6 h-6" />
                                        </div>
                                        <div className="pt-1">
                                            <p className="font-semibold mb-1 text-slate-800">Email</p>
                                            <a href="mailto:[Email]" className="text-sm text-slate-600 hover:text-orange-500 transition-colors font-medium">hallo@tatainovindo.com</a>
                                        </div>
                                    </div>

                                    <div className="flex items-start">
                                        <div className="w-12 h-12 rounded-2xl bg-white shadow-sm border border-orange-100 flex items-center justify-center mr-5 flex-shrink-0 transition-transform group-hover:scale-105 duration-300">
                                            <ClockIcon className="text-orange-500 w-6 h-6" />
                                        </div>
                                        <div className="pt-1">
                                            <p className="font-semibold mb-1 text-slate-800">Jam Operasional</p>
                                            <p className="text-sm text-slate-600">Sen. - Jum. : 08:00 - 16:30</p>
                                            <p className="text-sm text-slate-600">Minggu & Hari Libur : Tutup</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Kanan: Form Pengisian */}
                        <div className="lg:col-span-3 lg:py-4">
                            <h3 className="text-2xl font-bold font-heading text-slate-800 mb-6 hidden lg:block">Kirim Pesan Anda</h3>
                            
                            {isSubmitted && <div className="bg-emerald-50 border border-emerald-200 text-emerald-700 px-6 py-4 rounded-2xl mb-6 flex items-center"><div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center mr-3"><span className="text-emerald-600 font-bold">✓</span></div><div><p className="font-bold">Pesan Terkirim!</p><p className="text-sm">Terima kasih, tim kami akan segera menghubungi Anda kembali.</p></div></div>}
                            {submitError && <div className="bg-red-50 border border-red-200 text-red-700 px-6 py-4 rounded-2xl mb-6"><p className="font-bold">Gagal Mengirim</p><p className="text-sm">{submitError}</p></div>}
                            
                            {!isSubmitted && (
                            <form onSubmit={handleSubmit} className="space-y-6">
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div>
                                        <label className="block text-sm font-semibold text-slate-700 mb-2">Nama Lengkap <span className="text-red-500">*</span></label>
                                        <input type="text" name="name" value={formData.name} onChange={handleChange} required placeholder="Masukkan nama Anda" className="w-full px-5 py-3.5 bg-slate-50 border border-transparent rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500/30 focus:border-orange-500 focus:bg-white transition-all text-sm shadow-sm"/>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-semibold text-slate-700 mb-2">Email <span className="text-red-500">*</span></label>
                                        <input type="email" name="email" value={formData.email} onChange={handleChange} required placeholder="email@contoh.com" className="w-full px-5 py-3.5 bg-slate-50 border border-transparent rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500/30 focus:border-orange-500 focus:bg-white transition-all text-sm shadow-sm"/>
                                    </div>
                                </div>
                                
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div>
                                        <label className="block text-sm font-semibold text-slate-700 mb-2">Nomor Telepon</label>
                                        <input type="tel" name="phone" value={formData.phone} onChange={handleChange} placeholder="0812xxxxxxxx" className="w-full px-5 py-3.5 bg-slate-50 border border-transparent rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500/30 focus:border-orange-500 focus:bg-white transition-all text-sm shadow-sm"/>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-semibold text-slate-700 mb-2">Produk yang Diminati</label>
                                        <input type="text" name="product" value={formData.product} onChange={handleChange} placeholder="Contoh: Label, Sticker" className="w-full px-5 py-3.5 bg-slate-50 border border-transparent rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500/30 focus:border-orange-500 focus:bg-white transition-all text-sm shadow-sm"/>
                                    </div>
                                </div>

                                <div>
                                    <label className="block text-sm font-semibold text-slate-700 mb-2">Detail Pesan / Kebutuhan <span className="text-red-500">*</span></label>
                                    <textarea name="message" rows="4" value={formData.message} onChange={handleChange} required placeholder="Ceritakan detail spesifikasi produk atau layanan yang Anda butuhkan..." className="w-full px-5 py-3.5 bg-slate-50 border border-transparent rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500/30 focus:border-orange-500 focus:bg-white transition-all text-sm shadow-sm resize-none"></textarea>
                                </div>

                                <button type="submit" className="flex items-center justify-center w-full sm:w-auto px-8 py-4 bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-xl shadow-[0_8px_20px_rgb(249,115,22,0.3)] hover:shadow-[0_8px_25px_rgb(249,115,22,0.4)] hover:-translate-y-1 transition-all duration-300">
                                    <SendIcon className="w-5 h-5 mr-2" />
                                    Kirim Pesan
                                </button>
                            </form>
                            )}
                        </div>
                    </div>

                    {/* Google Maps Section di bagian bawah */}
                    <div className="mt-16 pt-10 border-t border-slate-100">
                        <div className="flex items-center justify-between mb-6">
                            <h3 className="text-2xl font-bold font-heading text-slate-800">Lokasi Perusahaan</h3>
                        </div>
                        <div className="overflow-hidden rounded-2xl shadow-sm border border-slate-200 bg-slate-100 h-[400px]">
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3963.017702994985!2d106.8043003!3d-6.6447229!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69cf466a46aaa3%3A0x6e7a282478ae8c55!2sWarehouse%20Pabrik%20Sticker!5e0!3m2!1sid!2sid!4v1782278330176!5m2!1sid!2sid" width="100%" height="100%" style={{ border: 0 }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Peta Lokasi Perusahaan"></iframe>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </>
  );
};

// --- Komponen Utama Aplikasi ---
const App = () => {
  const [currentPage, setCurrentPage] = useState('beranda');
  const [pageProps, setPageProps] = useState({});
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isHeaderScrolled, setIsHeaderScrolled] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isHeaderVisible, setIsHeaderVisible] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > 10) setIsHeaderScrolled(true);
      else setIsHeaderScrolled(false);
      
      if (currentScrollY > lastScrollY && currentScrollY > 100) setIsHeaderVisible(false);
      else setIsHeaderVisible(true);
      
      setLastScrollY(currentScrollY <= 0 ? 0 : currentScrollY);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  const navigate = (page, props = {}) => {
    setCurrentPage(page);
    setPageProps(props);
    setIsMobileMenuOpen(false);
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    const handleContextmenu = e => e.preventDefault()
    document.addEventListener('contextmenu', handleContextmenu)
    return () => document.removeEventListener('contextmenu', handleContextmenu)
  }, [])

  let content;
  switch (currentPage) {
    case 'beranda': content = <HomePage navigate={navigate} />; break;
    case 'tentang': content = <AboutPage />; break;
    case 'produk': content = <ProductsPage navigate={navigate} />; break;
    case 'kontak': content = <ContactPage initialProduct={pageProps.product} />; break;
    default: content = <HomePage navigate={navigate} />;
  }

  const navLinks = [
    { name: 'Beranda', page: 'beranda' },
    { name: 'Tentang Kami', page: 'tentang' },
    { name: 'Produk', page: 'produk' },
    { name: 'Kontak', page: 'kontak' },
  ];

const headerBgClass = isHeaderScrolled || isMobileMenuOpen ? 'bg-slate-900 shadow-md' : 'bg-transparent';
  const headerTransformClass = isHeaderVisible ? 'translate-y-0' : '-translate-y-full';

  return (
    // Penambahan font-sans di wrapper utama untuk body text
    <div className="min-h-screen bg-slate-100 font-sans">
      <header className={`text-white fixed top-0 w-full z-50 transition-all duration-300 ${headerBgClass} ${headerTransformClass}`}>
        <div className="container mx-auto px-4 h-[88px] flex justify-between items-center">
<div className="text-2xl font-bold cursor-pointer hover:opacity-80 transition-opacity" onClick={() => navigate('beranda')}>
            <img 
              src={ (isHeaderScrolled || isMobileMenuOpen) 
                ? "https://ik.imagekit.io/DBoyz/images/logo%20tata%20inovindo%20(1).png" 
                : "https://ik.imagekit.io/DBoyz/images/logo%20tata%20inovindo%20putih.png" 
              } 
              alt="Logo Tata" 
              className="h-8 md:h-12 object-contain transition-all duration-300"
            />
          </div>
          
          <nav className="hidden md:flex space-x-2">
            {navLinks.map(link => (
              <button key={link.page} onClick={() => navigate(link.page)} className={`px-3 py-2 rounded-md text-sm font-medium hover:bg-slate-700 hover:text-orange-400 transition-all duration-200 ${currentPage === link.page ? 'bg-orange-500 text-white shadow-sm' : 'text-slate-200'}`}>
                {link.name}
              </button>
            ))}
          </nav>
          <div className="md:hidden">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-white focus:outline-none p-2">
              {isMobileMenuOpen ? <XIcon className="w-7 h-7"/> : <MenuIcon className="w-7 h-7"/>}
            </button>
          </div>
        </div>
        {isMobileMenuOpen && (
          <div className="md:hidden bg-slate-800 border-t border-slate-700">
            <nav className="flex flex-col space-y-1 px-2 py-3">
              {navLinks.map(link => (
                <button key={link.page} onClick={() => navigate(link.page)} className={`block w-full text-left px-3 py-3 rounded-md text-base font-medium hover:bg-slate-700 hover:text-orange-400 transition-all duration-200 ${currentPage === link.page ? 'bg-orange-500 text-white' : 'text-slate-200'}`}>
                  {link.name}
                </button>
              ))}
            </nav>
          </div>
        )}
      </header>

      <main>{content}</main>

      {/* Footer */}
      <footer className="bg-slate-900 text-slate-300 py-12 md:py-16 border-t-[6px] border-orange-500">
        <div className="container mx-auto px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-12 gap-10 lg:gap-12">
                
                {/* Kolom 1: Profil Perusahaan & Logo (Diberi ruang lebih lebar) */}
                <div className="md:col-span-5 lg:col-span-4 flex flex-col items-center md:items-start text-center md:text-left">
                    <div className="mb-6 cursor-pointer hover:opacity-90 transition-opacity" onClick={() => navigate('beranda')}>
                        <img src="https://ik.imagekit.io/DBoyz/images/logo%20tata%20inovindo%20(1).png" alt="Logo PT Tata Inovindo" className="h-16 object-contain"/>
                    </div> 
                    <p className="text-sm text-slate-400 mb-6 leading-relaxed text-justify">
                        Mitra terpercaya Anda dalam industri manufaktur, penyablonan presisi, dan pemotongan material berkualitas tinggi untuk komponen otomotif dan elektronik sejak tahun 2011.
                    </p>
                    <div className="mt-auto">
                        <p className="text-xs text-slate-500 mb-2 font-semibold tracking-wider uppercase">Tersertifikasi Oleh:</p>
                        <div className="bg-white/5 p-2 rounded-xl inline-block border border-white/10 hover:bg-white/10 transition-colors cursor-default">
                            <img src="https://ik.imagekit.io/DBoyz/images/Logo%20SGS" alt="Sertifikat ISO 9001" className="h-10 object-contain filter brightness-110"/>
                        </div>
                    </div>
                </div>

                {/* Spacing transparan untuk pemisah grid (hanya terlihat di layar besar) */}
                <div className="hidden lg:block lg:col-span-1"></div>

                {/* Kolom 2: Navigasi / Tautan Cepat */}
                <div className="md:col-span-3 flex flex-col items-center md:items-start text-center md:text-left">
                    <h5 className="text-lg font-bold font-heading mb-2 text-white">Navigasi</h5>
                    {/* Aksen Garis Oranye */}
                    <div className="w-12 h-1 bg-orange-500 rounded-full mb-6"></div>
                    <ul className="space-y-3 w-full">
                        <li>
                            <button onClick={() => navigate('beranda')} className="text-slate-400 hover:text-orange-400 transition-colors text-sm flex items-center justify-center md:justify-start w-full group">
                                <ChevronRightIcon className="w-4 h-4 mr-1 opacity-0 -ml-5 group-hover:opacity-100 group-hover:ml-0 transition-all duration-300 text-orange-500" />
                                Beranda
                            </button>
                        </li>
                        <li>
                            <button onClick={() => navigate('tentang')} className="text-slate-400 hover:text-orange-400 transition-colors text-sm flex items-center justify-center md:justify-start w-full group">
                                <ChevronRightIcon className="w-4 h-4 mr-1 opacity-0 -ml-5 group-hover:opacity-100 group-hover:ml-0 transition-all duration-300 text-orange-500" />
                                Tentang Kami
                            </button>
                        </li>
                        <li>
                            <button onClick={() => navigate('produk')} className="text-slate-400 hover:text-orange-400 transition-colors text-sm flex items-center justify-center md:justify-start w-full group">
                                <ChevronRightIcon className="w-4 h-4 mr-1 opacity-0 -ml-5 group-hover:opacity-100 group-hover:ml-0 transition-all duration-300 text-orange-500" />
                                Produk Unggulan
                            </button>
                        </li>
                        <li>
                            <button onClick={() => navigate('kontak')} className="text-slate-400 hover:text-orange-400 transition-colors text-sm flex items-center justify-center md:justify-start w-full group">
                                <ChevronRightIcon className="w-4 h-4 mr-1 opacity-0 -ml-5 group-hover:opacity-100 group-hover:ml-0 transition-all duration-300 text-orange-500" />
                                Hubungi Kami
                            </button>
                        </li>
                    </ul>
                </div>

                {/* Kolom 3: Info Kontak Penuh */}
                <div className="md:col-span-4 flex flex-col items-center md:items-start text-center md:text-left">
                    <h5 className="text-lg font-bold font-heading mb-2 text-white">Hubungi Kami</h5>
                    {/* Aksen Garis Oranye */}
                    <div className="w-12 h-1 bg-orange-500 rounded-full mb-6"></div>
                    <address className="text-sm not-italic space-y-4 w-full">
                        <div className="flex items-start justify-center md:justify-start">
                            <MapPinIcon className="w-5 h-5 text-orange-400 mr-3 flex-shrink-0 mt-0.5" />
                            <p className="text-slate-400 leading-relaxed">Jalan Ciranjang 41 RT 01 RW 03 Pamoyanan, Bogor Selatan, Bogor, Jawa Barat</p>
                        </div>
                        <div className="flex items-center justify-center md:justify-start">
                            <PhoneIcon className="w-5 h-5 text-orange-400 mr-3 flex-shrink-0" />
                            <a href="tel:[NomorTeleponPerusahaan]" className="text-slate-400 hover:text-orange-400 transition-colors">085186837474</a>
                        </div>
                        <div className="flex items-center justify-center md:justify-start">
                            <MailIcon className="w-5 h-5 text-orange-400 mr-3 flex-shrink-0" />
                            <a href="mailto:[AlamatEmail]" className="text-slate-400 hover:text-orange-400 transition-colors">hallo@tatainovindo.com</a>
                        </div>
                    </address>
                </div>
            </div>

            {/* Garis Pemisah & Copyright */}
            <div className="mt-12 md:mt-16 border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center">
                <p className="text-sm text-slate-500 mb-4 md:mb-0">
                    © {new Date().getFullYear()} <span className="text-slate-300 font-semibold">PT TATA INOVINDO</span>. Semua Hak Dilindungi.
                </p>
                

            </div>
        </div>
      </footer>
    </div>
  );
};

export default App;